import React from 'react';
import { Trans } from 'react-i18next';
import { useParams } from 'react-router';

import styled from '@emotion/styled';
import { Languages, supportEmail } from '@repo/constants';
import { getServiceName } from '@repo/utils';

import { closeModal } from 'store/modalStackStore';
import { translation } from 'utils/translation';

import ExternalLink from 'components/link/ExternalLink';
import Flex from 'components/util/Flex';

// 에셋들이 블락된 경우, 1회 노출시킬 목적으로 만들어짐
export default function AlertBlockedAssetsModal() {
  const { language } = useParams();
  const SUPPORT_EMAIL = supportEmail(language as Languages);

  return (
    <SModalWrapper>
      <SModalHeader>
        <p className="title">
          <Trans
            i18nKey="chat.rewards_modal_reclaimed"
            components={{
              link1: <ExternalLink to="https://discord.com/invite/FUb6scdgNR" />,
            }}
            values={{ string_email: SUPPORT_EMAIL }}
          />
        </p>
      </SModalHeader>
      <Flex justify="center">
        <SButton onClick={closeModal} $isTingle={getServiceName() === 'tingle'}>
          {translation('chat.rewards_modal_reclaimed_button')}
        </SButton>
      </Flex>
    </SModalWrapper>
  );
}

const SModalWrapper = styled.section`
  width: 100%;
  padding: 36px 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  @media ${({ theme }) => theme.device.small} {
    width: 330px;
  }
`;

const SModalHeader = styled.div`
  .title {
    ${({ theme }) => theme.font.head6_sb};
    text-align: center;
  }

  a {
    text-underline-offset: 4px;
    color: ${({ theme }) => theme.color.static.primary};
  }
`;

// 팅글 리워드 CTA: yellow/black (임시, 디자인 제안 Figma 1072:58012). 버블챗은 기존 primary/white 유지
const SButton = styled.button<{ $isTingle?: boolean }>`
  padding: 12px 0;
  width: 260px;
  border-radius: 8px;
  // background-color: ${({ theme }) => theme.palette.neutral[30]};
  background-color: ${({ theme, $isTingle }) => ($isTingle ? theme.color.brand.primary : theme.color.static.primary)};
  color: ${({ theme, $isTingle }) => ($isTingle ? '#000000' : theme.color.static.white)};
  ${({ theme }) => theme.font.body1_m};
`;
